export const roundUpTransaction = (transaction) => {
    console.log(">>>>>> transaction", transaction);
    let roundUpValue = transaction.toString()

    if(roundUpValue.includes('.')){
        return Number(transaction).toFixed(2)
    } else {
        return Number(transaction)
    }
}


// WEBPACK FOOTER //
// ./src/utils/roundUpTransaction.js